/**
 * MKS-520 — TanStack Query hook for /api/manager/delivery/weekly-trend.
 *
 * The endpoint runs 8 period aggregations (one per week), so it is fetched only when the caller
 * enables it — the release flag is on and the People view is shown — and kept for 5 minutes.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchDeliveryWeeklyTrend, type DeliveryWeeklyTrend } from '../services/api/delivery';

export function useDeliveryWeeklyTrend(enabled: boolean) {
  return useQuery<DeliveryWeeklyTrend>({
    queryKey: ['manager', 'delivery', 'weekly-trend'],
    queryFn: fetchDeliveryWeeklyTrend,
    enabled,
    staleTime: 300_000,
  });
}
